module.exports = new __parcel__URL__("beetlejuice-annie-mcenroe.25abde5b.gif").toString();